import TeamBasicDetailsForm from './TeamBasicDetailsForm';

export default TeamBasicDetailsForm;
